import React from 'react';
import SectionTitle from './SectionTitle';
import ScrollReveal from './ScrollReveal';

const ContactSection = () => {
  return (
    <section id="contact" className="section" style={styles.section}>
      <ScrollReveal>
        <SectionTitle text="CONTACT" />
      </ScrollReveal>
      
      <div style={styles.contactContainer}>
        <ScrollReveal delay={300}>
          <div style={styles.contactCard}>
            <div style={styles.contactHeader}>
              <div style={styles.glowingText}>CONNECT WITH ME</div>
            </div>
            <div style={styles.socialLinks}>
              <a 
                href="https://linkedin.com/in/tomerkat" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={styles.socialLink}
              >
                <div style={styles.socialIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </div>
                <span style={styles.socialText}>LinkedIn</span>
              </a>
              
              {/* Add more social links as needed */}
              {/* Example for a GitHub link:
              <a 
                href="https://github.com/yourusername" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={styles.socialLink}
              >
                <div style={styles.socialIcon}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                </div>
                <span style={styles.socialText}>GitHub</span>
              </a>
              */}
            </div>
            <div style={styles.emailContainer}>
              <div style={styles.emailLabel}>EMAIL</div>
              <a href="mailto:ktomer100@gmail.com" style={styles.emailLink}>
                ktomer100@gmail.com
              </a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '3rem 1rem',
    maxWidth: '1200px',
    margin: '0 auto 4rem',
    position: 'relative',
  },
  contactContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contactCard: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: '10px',
    border: '1px solid #0ff',
    boxShadow: '0 0 15px rgba(0, 255, 255, 0.3)',
    padding: '2rem',
    width: '100%',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  contactHeader: {
    marginBottom: '2rem',
    textAlign: 'center',
  },
  glowingText: {
    fontSize: '1.8rem',
    color: '#0ff',
    textShadow: '0 0 5px #0ff, 0 0 10px #0ff',
    letterSpacing: '3px',
  },
  socialLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    width: '100%',
    marginBottom: '2rem',
  },
  socialLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#fff',
    padding: '1rem',
    borderRadius: '5px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: '1px solid rgba(255, 0, 255, 0.3)',
    transition: 'all 0.3s ease',
    ':hover': {
      backgroundColor: 'rgba(255, 0, 255, 0.1)',
      borderColor: '#f0f',
      transform: 'translateY(-3px)',
      boxShadow: '0 5px 15px rgba(255, 0, 255, 0.2)',
    }
  },
  socialIcon: {
    marginRight: '1rem',
    color: '#f0f', // Neon pink
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
  },
  socialText: {
    fontSize: '1.2rem',
    letterSpacing: '1px',
  },
  emailContainer: {
    textAlign: 'center',
    marginTop: '1rem',
    width: '100%',
    padding: '1rem',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '5px',
    border: '1px solid rgba(0, 255, 255, 0.3)',
  },
  emailLabel: {
    fontSize: '1rem',
    color: '#0ff',
    marginBottom: '0.5rem',
    letterSpacing: '2px',
  },
  emailLink: {
    fontSize: '1.2rem',
    color: '#fff',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    ':hover': {
      color: '#0ff',
      textShadow: '0 0 5px #0ff',
    }
  }
};

export default ContactSection; 